var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.advanceMode
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "d-flex justify-content-between align-items-center"
              },
              [
                _c("section-title", {
                  attrs: {
                    "bg-icon": "white",
                    "container-class": "mt-1",
                    content: "Favoritos",
                    icon: "fas fa-star font-16 text-warning"
                  }
                }),
                _vm.advanceMode
                  ? _c("div", { staticClass: "view-toggle" }, [
                      _c(
                        "button",
                        {
                          staticClass: "view-toggle-btn",
                          class: { active: _vm.viewMode === "list" },
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.setViewMode("list")
                            }
                          }
                        },
                        [_c("i", { staticClass: "fas fa-list" })]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "view-toggle-btn",
                          class: { active: _vm.viewMode === "grid" },
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.setViewMode("grid")
                            }
                          }
                        },
                        [_c("i", { staticClass: "fas fa-th-large" })]
                      )
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm.optionFavoriteList.length > 0
              ? _c(
                  "div",
                  [
                    _vm.filteredOptionFavoriteList.length > 0
                      ? _c("square-option", {
                          attrs: {
                            menu: _vm.filteredOptionFavoriteList,
                            "show-star": "",
                            "view-mode": _vm.effectiveViewMode
                          },
                          on: { remove: _vm.removeToFavorites }
                        })
                      : _c(
                          "div",
                          { staticClass: "d-block ml-auto mr-auto mb-2" },
                          [
                            _c("empty", {
                              attrs: {
                                icon: "fal fa-search",
                                text:
                                  "No se encontraron resultados para su búsqueda."
                              }
                            })
                          ],
                          1
                        )
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "d-block ml-auto mr-auto mb-2" },
                  [
                    _c("empty", {
                      attrs: {
                        icon: "fal fa-lightbulb-exclamation",
                        text:
                          "Puede oprimir la estrella en las tarjetas para agregarlas como favoritos."
                      }
                    })
                  ],
                  1
                ),
            _c("div", { attrs: { id: "border" } })
          ])
        : _vm._e(),
      _vm.filteredOptionList.length > 0
        ? _c("square-option", {
            attrs: {
              menu: _vm.filteredOptionList,
              "show-star": _vm.advanceMode,
              "view-mode": _vm.effectiveViewMode
            },
            on: { add: _vm.addToFavorites, remove: _vm.removeToFavorites }
          })
        : _vm.hasSearch
        ? _c(
            "div",
            { staticClass: "d-block ml-auto mr-auto mb-2" },
            [
              _c("empty", {
                attrs: {
                  icon: "fal fa-search",
                  text: "No se encontraron resultados para su búsqueda."
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }